import { useGetFlightInfoQuery, useGetItineraryDataQuery } from '@/src/api/rtkQuery/itineraryApi'
import { SegmentBaggageLoader } from '@/src/components/desktop/itinerary/loadingShimmers'
import useGetItineraryId from '@/src/hooks/itinerary/useGetItineraryId'
// import { formatBaggageInfo } from '@/src/utils/translation/translateBaggage'
import { useTranslations } from 'next-intl'
import SegmentBaggage from './segmentBaggage'

const SegmentBaggageWrapper = ({ segmentKey }: { segmentKey: string }) => {
    const itineraryId = useGetItineraryId()
    const t = useTranslations('common')
    // const locale = useLocale()
    const { meta } = useGetItineraryDataQuery(
        {
            itineraryId
        },
        {
            selectFromResult: ({ data }) => ({
                meta: data?.meta || {}
            })
        }
    )
    const { fareFamilyEnabledOnReview } = meta
    const {
        data,
        isLoading: isFlightMinirulesInfoLoading,
        isUninitialized
    } = useGetFlightInfoQuery(
        {
            itineraryId
        },
        {
            skip: fareFamilyEnabledOnReview
        }
    )

    const baggageData = data?.freeBaggageInfoResponse?.BI?.[segmentKey]
    const { cab = '', cib = '', freeText = '' } = baggageData || {}
    const viewBaggageCta = t('viewBaggageCta')
    const cabinBaggageCta = t('cabinBaggage')
    const checkinBaggageCta = t('checkinBaggage')
    const notAllowedText = t('Not allowed')

    // const formattedCab = formatBaggageInfo(cab, locale)
    // const formattedCib = formatBaggageInfo(cib, locale)

    if (fareFamilyEnabledOnReview || isUninitialized) {
        return null
    }
    if (isFlightMinirulesInfoLoading) {
        return <SegmentBaggageLoader />
    }

    return (
        <SegmentBaggage
            cab={cab || notAllowedText}
            cib={cib || notAllowedText}
            freeText={freeText}
            viewBaggageCta={viewBaggageCta}
            cabinBaggageCta={cabinBaggageCta}
            checkinBaggageCta={checkinBaggageCta}
        />
    )
}

export default SegmentBaggageWrapper
